/* eslint-disable */
import React, { useState, useEffect, Component } from 'react';
import Confetti from 'react-confetti'; 
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
import { HashRouter as Router, Routes, Route, Navigate, useNavigate, useLocation, Link } from 'react-router-dom';

import { auth, db, storage } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider, updateEmail, updatePassword, sendPasswordResetEmail, confirmPasswordReset, signInWithCustomToken } from 'firebase/auth';
import { doc, setDoc, getDoc, updateDoc, collection, getDocs, getCountFromServer } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { translations, taskPools } from './config';
import './App.css';
import { Analytics } from '@vercel/analytics/react';
import Terms from './Terms'; // Upewnij się, że ścieżka jest poprawna względem Twoich folderów
import Privacy from './Privacy';

// --- CZARNA LISTA NICKÓW (PROFANITY FILTER) ---
const bannedWords = [
  'nigger', 'nigga', 'niga', 'niiga', 'nyga', 'nazi', 'fuck', 'fuk', 'bitch', 'cunt', 'whore', 'slut', 'rape', 'faggot', 'fag', 'retard', 'dick', 'pussy', 'asshole', 'pedophile', 'pedo', 'porn', 'cock', 'boobs', 'tits', 'cum', 'shit', 'wanker', 'twat', 'nibba', 'nibber', 'kys', 'kyself', 'kysbro', 'crap', 'bastard', 'dyke', 'kike', 'chink', 'gook',
  'kurw', 'kurv', 'kvrw', 'jeb', 'jebac', 'jebany', 'chuj', 'huj', 'pizd', 'cwel', 'szmat', 'pedal', 'pedał', 'dziwk', 'zjeb', 'fiut', 'kutas', 'dupa', 'cip', 'suk', 'zyd', 'żyd', 'konfident', 'frajer', 'debil', 'idiot', 'skurw', 'skurwysyn', 'pierdol', 'rucha', 'ruchanie', 'rucham', 'dymam', 'sperma', 'gnoj', 'gówno', 'gowno', 'sra', 'srac',
  'twojastara', 'twojaryta', 'matke', 'ojca', 'stara', 'stary', 'twojamatka', 'twojojciec', 'twoj', 'twoja',
  'cyka', 'blyat', 'blyad', 'pidar', 'pizdec', 'suka', 'xuy', 'hui', 'chmo', 'gandon', 'mudak', 'dalbaeb',
  'hitler', 'stalin', 'lenin', 'putin', 'putler', 'osama', 'binladen', 'mussolini', 'polpot', 'mao', 'himmler', 'goebbels', 'breivik', 'bandera', 'tusk',
  'admin', 'administrator', 'moderator', 'mod', 'peekit', 'support', 'owner', 'system', 'official', 'bot', 'server', 'valve', 'cs2', 'steam', 'trade', 'scam', 'free', 'skins', 'csgo',
  'cheat', 'hacker', 'wallhack', 'aimbot', 'spinbot', 'triggerbot', 'esp', 'script', 'smurf', 'boost'
];

const isProfane = (text) => {
  if (!text) return false;
  
  let normalized = text.toLowerCase();
  
  const leetMap = {
    '1': 'i', '3': 'e', '4': 'a', '0': 'o', '5': 's', '7': 't', '8': 'b', '9': 'g',
    'v': 'u', '$': 's', '@': 'a', '!': 'i', '|': 'i', '(': 'c', '<': 'c', '[': 'c',
    'y': 'i' 
  };
  
  for (let key in leetMap) {
    normalized = normalized.replaceAll(key, leetMap[key]);
  }
  
  normalized = normalized.replace(/[^a-z]/g, '');
  
  let collapsed = normalized.replace(/(.)\1+/g, '$1');
  
  return bannedWords.some(word => {
    let collapsedWord = word.replace(/(.)\1+/g, '$1');
    return collapsed.includes(collapsedWord) || normalized.includes(word);
  });
};

const defaultStats = { 'Aim': { level: 1, xp: 0 }, 'Utility': { level: 1, xp: 0 }, 'Movement': { level: 1, xp: 0 } };

const getRequiredXp = (level) => {
  if (level <= 5) return 50;   
  if (level <= 15) return 100; 
  return 150;                  
};

const getTaskCountForLevel = (lvl) => {
  if (lvl === 'Beginner') return 3;
  if (lvl === 'Advanced') return 5;
  return 4; 
};

// --- PROFESJONALNY ALGORYTM TASOWANIA (FISHER-YATES) ---
const shuffleArray = (array) => {
  if (!array || !Array.isArray(array)) return [];
  const newArr = [...array];
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
};

// --- DYNAMICZNY MIKS STANDARD ---
const generateStandardTasks = (skillLevel) => {
  const aimPool = shuffleArray(taskPools['Aim']?.[skillLevel] || []);
  const utilPool = shuffleArray(taskPools['Utility']?.[skillLevel] || []);
  const movPool = shuffleArray(taskPools['Movement']?.[skillLevel] || []);
  
  let tasks = [];
  if (skillLevel === 'Beginner') {
    const other = Math.random() > 0.5 ? utilPool[0] : movPool[0];
    tasks = [aimPool[0], aimPool[1], other].filter(Boolean);
  } else if (skillLevel === 'Intermediate') {
    const other = Math.random() > 0.5 ? utilPool[0] : movPool[0];
    tasks = [aimPool[0], aimPool[1], aimPool[2], other].filter(Boolean);
  } else {
    tasks = [aimPool[0], aimPool[1], aimPool[2], utilPool[0], movPool[0]].filter(Boolean);
  }
  return shuffleArray(tasks); 
};

const getNewTasksForPlan = (planName, skillLevel) => {
  if (!planName || !skillLevel) return [];
  if (planName === 'Standard') {
    return generateStandardTasks(skillLevel);
  } else if (taskPools[planName] && taskPools[planName][skillLevel]) {
    const taskCount = getTaskCountForLevel(skillLevel);
    const shuffledTasks = shuffleArray(taskPools[planName][skillLevel]);
    return shuffledTasks.slice(0, taskCount);
  }
  return [];
};

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) { return initialValue; }
  });
  useEffect(() => {
    try { window.localStorage.setItem(key, JSON.stringify(storedValue)); } 
    catch (error) {}
  }, [key, storedValue]);
  return [storedValue, setStoredValue];
}

const playTaskSound = () => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return; 
    const audioCtx = new AudioContext();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(600, audioCtx.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(100, audioCtx.currentTime + 0.05);
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.05);
    oscillator.start(audioCtx.currentTime);
    oscillator.stop(audioCtx.currentTime + 0.05);
  } catch (error) {
    console.log("Audio API failed:", error);
  }
};

// --- BEZPIECZNE AWATARY ZAPASOWE (BASE64) ---
const FALLBACK_AVATAR_666 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDIxdi0yYTQgNCAwIDAgMC00LTRIOGE0IDQgMCAwIDAtNCA0djIiPjwvcGF0aD48Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiPjwvY2lyY2xlPjwvc3ZnPg==";
const FALLBACK_AVATAR_888 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODg4IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDIxdi0yYTQgNCAwIDAgMC00LTRIOGE0IDQgMCAwIDAtNCA0djIiPjwvcGF0aD48Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiPjwvY2lyY2xlPjwvc3ZnPg==";
// --- PODRASOWANE IKONY WEKTOROWE SVG (E-SPORTS EDITION) ---
const Icons = {
  Fire: ({ size = 28, isGrayscale = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ filter: isGrayscale ? 'grayscale(100%) opacity(0.4)' : 'drop-shadow(0 2px 8px rgba(249, 115, 22, 0.75))', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <defs>
        <linearGradient id="fireBg" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#ea580c" />
          <stop offset="50%" stopColor="#ef4444" />
          <stop offset="100%" stopColor="#f87171" />
        </linearGradient>
        <linearGradient id="fireMid" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#fbbf24" />
        </linearGradient>
        <linearGradient id="fireCore" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#fef08a" />
          <stop offset="100%" stopColor="#ffffff" />
        </linearGradient>
      </defs>
      <path d="M12 22C7 22 4 18 4 13.5C4 9 9 4 12 0.5C15 4 20 9 20 13.5C20 18 17 22 12 22Z" fill="url(#fireBg)" />
      <path d="M12 20C8.5 20 6.5 17 6.5 14C6.5 11 9 7.5 12 4.5C15 7.5 17.5 11 17.5 14C17.5 17 15.5 20 12 20Z" fill="url(#fireMid)" />
      <path d="M12 17.5C10 17.5 8.5 15.5 8.5 14C8.5 12.5 10 10.5 12 8.5C14 10.5 15.5 12.5 15.5 14C15.5 15.5 14 17.5 12 17.5Z" fill="url(#fireCore)" />
    </svg>
  ),
  Diamond: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ filter: 'drop-shadow(0 4px 10px rgba(234, 179, 8, 0.45))' }}>
      <polygon points="8,4 16,4 21,10 3,10" fill="#fef08a" />
      <polygon points="3,10 8,4 2,10" fill="#fde047" />
      <polygon points="21,10 16,4 22,10" fill="#facc15" />
      <polygon points="3,10 21,10 12,22" fill="#eab308" />
      <polygon points="2,10 3,10 12,22" fill="#ca8a04" />
      <polygon points="22,10 21,10 12,22" fill="#a16207" />
      <polygon points="8,4 16,4 12,10" fill="#ffffff" opacity="0.6" />
    </svg>
  ),
  Target: ({ size = 18, color = "#ef4444" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="7" />
      <line x1="12" y1="1" x2="12" y2="5" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="1" y1="12" x2="5" y2="12" />
      <line x1="19" y1="12" x2="23" y2="12" />
      <circle cx="12" cy="12" r="1.5" fill={color} />
    </svg>
  ),
  Brain: ({ size = 18, color = "#eab308" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
       <circle cx="12" cy="12" r="10"></circle>
       <line x1="12" y1="2" x2="12" y2="22"></line>
       <line x1="2" y1="12" x2="22" y2="12"></line>
       <circle cx="16" cy="8" r="1.5" fill={color} stroke="none"></circle>
       <circle cx="8" cy="16" r="1.5" fill={color} stroke="none"></circle>
    </svg>
  ),
  Bolt: ({ size = 18, color = "#3b82f6" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill={`${color}20`} />
    </svg>
  ),
  Crown: ({ size = 18, color = "#a855f7" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="2 20 22 20 19 4 15 10 12 3 9 10 5 4 2 20" fill={`${color}30`} />
    </svg>
  ),
  Egg: ({ size = 18, color = "#a0a0a0" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" fill={`${color}20`}/>
    </svg>
  ),
  Trophy: ({ size = 20, color = "#eab308" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ filter: `drop-shadow(0 2px 6px ${color}60)` }}>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
      <path d="M4 22h16"></path>
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
    </svg>
  ),
  Avatar: ({ size = 24, color = "#888" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  )
};

const getAchievements = (player, t) => {
  let badges = [];
  
  if (player.streak >= 3) badges.push({ icon: <Icons.Fire size={20} />, name: t('badgeOnFire') || 'On Fire (3+)', color: '#ef4444' });
  if (player.streak >= 10) badges.push({ icon: <Icons.Target size={20} color="#f97316" />, name: t('badgeStreak10') || 'Dedicated (10+)', color: '#f97316' });
  if (player.streak >= 100) badges.push({ icon: <Icons.Diamond size={20} color="#eab308" />, name: t('badgeStreak100') || 'Centurion (100+)', color: '#eab308' });
  if (player.streak >= 1000) badges.push({ icon: <Icons.Crown size={20} color="#a855f7" />, name: t('badgeStreak1000') || 'God Tier (1000+)', color: '#a855f7' });
  
  if (player.aim >= 5) badges.push({ icon: <Icons.Target size={18} color="#ef4444" />, name: t('badgeSharpshooter') || 'Sharpshooter', color: '#ef4444' });
  if (player.util >= 5) badges.push({ icon: <Icons.Brain size={18} color="#eab308" />, name: t('badgeTactician') || 'Tactician', color: '#eab308' });
  if (player.mov >= 5) badges.push({ icon: <Icons.Bolt size={18} color="#3b82f6" />, name: t('badgeSpeedster') || 'Speedster', color: '#3b82f6' });
  if (player.level >= 10) badges.push({ icon: <Icons.Crown size={18} color="#a855f7" />, name: t('badgeVeteran') || 'Veteran', color: '#a855f7' });
  
  if (badges.length === 0) badges.push({ icon: <Icons.Egg size={18} color="#a0a0a0" />, name: t('badgeRookie') || 'Rookie', color: '#a0a0a0' });
  return badges;
};

// --- PROFESJONALNY KOMPONENT ODZNAKI (CUSTOM TOOLTIP) ---
const PlayerBadge = ({ badge }) => (
  <div className="neon-badge-wrapper">
    <div 
      className="neon-badge-icon" 
      style={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        backgroundColor: '#111',
        borderRadius: '50%',
        border: `1.5px solid ${badge.color}`, 
        boxShadow: `0 0 10px ${badge.color}40, inset 0 0 5px ${badge.color}20`, 
        cursor: 'pointer'
      }}
    >
      {badge.icon}
    </div>
    <div className="custom-tooltip">
      {badge.name}
    </div>
  </div>
);

function MainApp() {
  const navigate = useNavigate();
  const location = useLocation();

  const [lang, setLang] = useLocalStorage('peekit_lang', 'en');
  const t = (key) => translations[lang]?.[key] || translations['en'][key];
  const mapsData = translations[lang]?.mapsList || translations['en'].mapsList;

  const [cookiesAccepted, setCookiesAccepted] = useLocalStorage('peekit_cookies_accepted', false);
  const [isSavingUsername, setIsSavingUsername] = useState(false);
  const [isClaimingReward, setIsClaimingReward] = useState(false);

  // --- ZMIANA: Dodajemy authUser, który będzie rzetelnie wymuszał re-rendery ---
  const hasSteamToken = new URLSearchParams(window.location.search).has('token');
  const [authUser, setAuthUser] = useState(null); 
  const [currentEmail, setCurrentEmail] = useState('');
  const [isCheckingAuth, setIsCheckingAuth] = useState(true); // Zawsze blokujemy na start
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  
  const [authMode, setAuthMode] = useState('login'); 
  const [resetCode, setResetCode] = useState(null);
  
  const [username, setUsername] = useLocalStorage('peekit_username', '');
  const [avatarUrl, setAvatarUrl] = useLocalStorage('peekit_avatar', null);
  const [skillLevel, setSkillLevel] = useLocalStorage('peekit_skill_level', '');
  const [selectedPlan, setSelectedPlan] = useLocalStorage('peekit_plan', '');
  const [steamUrl, setSteamUrl] = useLocalStorage('peekit_steam', '');
  const [accountCreatedDate, setAccountCreatedDate] = useLocalStorage('peekit_account_created', null);
  const [streak, setStreak] = useLocalStorage('peekit_streak', 0); 
  const [lifetimeTasksCompleted, setLifetimeTasksCompleted] = useLocalStorage('peekit_lifetime', 0); 
  const [userStats, setUserStats] = useLocalStorage('peekit_stats', defaultStats);
  
  const [calendarData, setCalendarData] = useLocalStorage('peekit_calendar_data', {});
  const [resetsToday, setResetsToday] = useLocalStorage('peekit_resets', 0);
  const [lastResetDate, setLastResetDate] = useLocalStorage('peekit_last_reset_date', '');
  const [lastCompletedDate, setLastCompletedDate] = useLocalStorage('peekit_last_completed', null);
  
  const [dailyTasks, setDailyTasks] = useLocalStorage('peekit_daily_tasks', []);
  const [completedTasks, setCompletedTasks] = useLocalStorage('peekit_completed_tasks', []);

  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [tempUsername, setTempUsername] = useState('');
  const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
  const [newEmailInput, setNewEmailInput] = useState('');
  const [newPasswordInput, setNewPasswordInput] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isTrainingActive, setIsTrainingActive] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [customAlert, setCustomAlert] = useState({ isOpen: false, type: 'alert', title: '', message: '', onConfirm: null });
  
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState('');

  const [todayIndex, setTodayIndex] = useState(0);
  const [currentKey, setCurrentKey] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState(null); 
  
  const [viewedDate, setViewedDate] = useState(new Date());

  const [draftName, setDraftName] = useState(username);
  const [draftLevel, setDraftLevel] = useState(skillLevel);
  const [draftPlan, setDraftPlan] = useState(selectedPlan);
  const [draftSteamUrl, setDraftSteamUrl] = useState(steamUrl);
  const [draftLang, setDraftLang] = useState(lang);

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoadingLeaderboard, setIsLoadingLeaderboard] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [lbPage, setLbPage] = useState(1); 
  
  const [totalPlatformPlayers, setTotalPlatformPlayers] = useState(0);

  const getActiveText = () => {
    if(lang === 'pl') return 'Aktywnych graczy';
    if(lang === 'uk') return 'Гравців онлайн';
    if(lang === 'es') return 'Jugadores activos';
    if(lang === 'de') return 'Aktive Spieler';
    if(lang === 'fr') return 'Joueurs actifs';
    return 'Active players';
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');
    if (mode === 'resetPassword' && oobCode) {
      setResetCode(oobCode);
      setAuthMode('new-password');
    }
  }, []);

  // --- OBSŁUGA POWROTU ZE STEAM ---
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const steamId = searchParams.get('steamId');
    const steamName = searchParams.get('name');
    const rawSteamAvatar = searchParams.get('avatar');
    const steamAvatar = rawSteamAvatar ? rawSteamAvatar.replace('http://', 'https://') : null;

    if (token && steamId) {
      const loginSteamUser = async () => {
        setIsCheckingAuth(true); // Trzymamy ekran ładowania!
        try {
          const userCredential = await signInWithCustomToken(auth, token);
          const user = userCredential.user;
          const userDocRef = doc(db, "users", user.uid);
          const userDoc = await getDoc(userDocRef);

          const steamProfileUrl = `https://steamcommunity.com/profiles/${steamId}/`;

          if (!userDoc.exists()) {
            const creationDate = new Date().toDateString();
            await setDoc(userDocRef, {
              email: '', 
              username: steamName || '', 
              createdAt: creationDate,
              streak: 0,
              stats: defaultStats,
              level: '',
              currentPlan: '',
              calendarData: {},
              lastCompletedDate: null,
              lifetimeTasksCompleted: 0,
              steamUrl: steamProfileUrl,
              photoURL: steamAvatar || '', 
              language: lang,
              dailyTasks: [],
              completedTasks: [],
              lastResetDate: '',
              resetsToday: 0
            });
            if (steamName) setUsername(steamName);
            if (steamAvatar) setAvatarUrl(steamAvatar);
            setSteamUrl(steamProfileUrl);
          } else {
            if (!userDoc.data().steamUrl) {
              await updateDoc(userDocRef, { steamUrl: steamProfileUrl });
              setSteamUrl(steamProfileUrl);
            }
            if (!userDoc.data().photoURL && steamAvatar) {
              await updateDoc(userDocRef, { photoURL: steamAvatar });
              setAvatarUrl(steamAvatar);
            }
          }
          
          window.history.replaceState(null, '', window.location.pathname);
        } catch (error) {
          console.error("Steam Auth Error:", error);
          showAlert('Error', 'Steam login failed.');
          setIsCheckingAuth(false);
        }
      };
      loginSteamUser();
    }
  }, []);

  useEffect(() => {
    const fetchTotalPlayers = async () => {
      try {
        const coll = collection(db, "users");
        const snapshot = await getCountFromServer(coll);
        setTotalPlatformPlayers(snapshot.data().count);
      } catch (e) {
        console.log("Nie udalo sie pobrac liczby graczy", e);
      }
    };
    fetchTotalPlayers();
  }, [currentEmail]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthUser(user); // --- KLUCZOWE: Mówimy Reactowi, że stan gracza się zmienił!
      if (user) {
        setCurrentEmail(user.email || ''); 
      } else {
        setCurrentEmail('');
        if (!hasSteamToken) {
          setIsCheckingAuth(false);
        }
      }
      setIsInitialLoad(false);
    });
    return () => unsubscribe();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchUserData = async () => {
      if (authUser) { // --- ZMIANA: Śledzimy niezawodny stan authUser
        setIsCheckingAuth(true); 
        try {
          const userDoc = await getDoc(doc(db, "users", authUser.uid));
          if (userDoc.exists()) {
            const dbData = userDoc.data();
            
            let loadedStats = dbData.stats || defaultStats;
            let needsFix = false;
            ['Aim', 'Utility', 'Movement'].forEach(skill => {
              let req = getRequiredXp(loadedStats[skill].level);
              if (loadedStats[skill].xp >= req) {
                needsFix = true;
                while (loadedStats[skill].xp >= req) {
                  loadedStats[skill].xp -= req;
                  loadedStats[skill].level += 1;
                  req = getRequiredXp(loadedStats[skill].level);
                }
              }
            });
            setUserStats(loadedStats);
            if (needsFix) {
              updateDoc(doc(db, "users", authUser.uid), { stats: loadedStats }).catch(()=>{});
            }

            if (dbData.streak !== undefined) setStreak(dbData.streak);
            if (dbData.level !== undefined) setSkillLevel(dbData.level);
            if (dbData.currentPlan !== undefined) setSelectedPlan(dbData.currentPlan);
            if (dbData.createdAt) setAccountCreatedDate(dbData.createdAt);
            if (dbData.calendarData) setCalendarData(dbData.calendarData);
            if (dbData.lastCompletedDate) setLastCompletedDate(dbData.lastCompletedDate);
            if (dbData.lifetimeTasksCompleted !== undefined) setLifetimeTasksCompleted(dbData.lifetimeTasksCompleted);
            if (dbData.username !== undefined) setUsername(dbData.username);
            if (dbData.steamUrl !== undefined) setSteamUrl(dbData.steamUrl);
            if (dbData.avatar) {
  setAvatarUrl(dbData.avatar.replace('http://', 'https://'));
} else if (dbData.photoURL) {
  setAvatarUrl(dbData.photoURL.replace('http://', 'https://'));
}
            if (dbData.dailyTasks !== undefined) setDailyTasks(dbData.dailyTasks);
            if (dbData.completedTasks !== undefined) setCompletedTasks(dbData.completedTasks);
            if (dbData.lastResetDate !== undefined) setLastResetDate(dbData.lastResetDate);
            if (dbData.resetsToday !== undefined) setResetsToday(dbData.resetsToday);
            
            if (dbData.language !== undefined) {
              setLang(dbData.language);
              setDraftLang(dbData.language);
            }
          }
        } catch(e) {
          console.error("Database error:", e);
        } finally {
          setIsCheckingAuth(false); // To definitywnie usuwa ekran ładowania
        }
      }
    };
    fetchUserData();
  }, [authUser]); // --- ZMIANA: Kiedy authUser wpadnie, uruchamiamy to!

  useEffect(() => {
    if (isCheckingAuth || !authUser) return;

    if (lastCompletedDate) {
      const todayDate = new Date();
      const lastDate = new Date(lastCompletedDate);
      const utcToday = Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
      const utcLast = Date.UTC(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
      const diffDays = Math.round((utcToday - utcLast) / (1000 * 60 * 60 * 24));

      if (diffDays > 1 && streak > 0) {
        setStreak(0);
        if (auth.currentUser) updateDoc(doc(db, "users", auth.currentUser.uid), { streak: 0 }).catch(()=>{});
      }
    } else if (streak > 0) {
      setStreak(0);
      if (auth.currentUser) updateDoc(doc(db, "users", auth.currentUser.uid), { streak: 0 }).catch(()=>{});
    }
  }, [lastCompletedDate, streak, isCheckingAuth, authUser]);

  useEffect(() => {
    if (location.pathname === '/settings') {
      setDraftName(username);
      setDraftLevel(skillLevel);
      setDraftPlan(selectedPlan);
      setDraftSteamUrl(steamUrl);
      setDraftLang(lang);
    }
  }, [location.pathname, username, skillLevel, selectedPlan, steamUrl, lang]);

  useEffect(() => {
    if (isCheckingAuth || isInitialLoad) return; 

    if (authUser) { // --- ZMIANA
      if (!skillLevel) {
        if (location.pathname !== '/level') navigate('/level');
      } else if (!selectedPlan) {
        if (location.pathname !== '/plans' && location.pathname !== '/level') navigate('/plans');
      } else {
        if (location.pathname === '/' || location.pathname === '/level' || location.pathname === '/plans') {
          navigate('/dashboard'); 
        }
      }
    }
  }, [authUser, skillLevel, selectedPlan, isCheckingAuth, isInitialLoad, location.pathname, navigate]);

  useEffect(() => {
    if (location.pathname === '/dashboard' && authUser && skillLevel && selectedPlan) {
      if (!username || username.trim() === '') {
        setIsUsernameModalOpen(true);
      }
    }
  }, [location.pathname, authUser, skillLevel, selectedPlan, username]);

  useEffect(() => {
    if (location.pathname === '/leaderboard' && authUser) {
      const fetchLeaderboard = async () => {
        setIsLoadingLeaderboard(true);
        try {
          const usersRef = collection(db, "users");
          const snapshot = await getDocs(usersRef);
          let players = [];
          
          const todayDate = new Date();
          const utcToday = Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());

          snapshot.forEach((docItem) => {
            const data = docItem.data();
            if (data.username && data.username.trim() !== '') {
              const aimLvl = data.stats?.Aim?.level || 1;
              const utilLvl = data.stats?.Utility?.level || 1;
              const movLvl = data.stats?.Movement?.level || 1;
              const totalLvl = aimLvl + utilLvl + movLvl;
              
              let displayStreak = data.streak || 0;
              if (data.lastCompletedDate) {
                const lastDate = new Date(data.lastCompletedDate);
                const utcLast = Date.UTC(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
                const diffDays = Math.round((utcToday - utcLast) / (1000 * 60 * 60 * 24));
                
                if (diffDays > 1) {
                  displayStreak = 0; 
                }
              } else if (displayStreak > 0) {
                displayStreak = 0; 
              }
              
              players.push({
                id: docItem.id,
                name: data.username,
                level: totalLvl,
                aim: aimLvl,
                util: utilLvl,
                mov: movLvl,
                avatar: (data.avatar || data.photoURL) ? (data.avatar || data.photoURL).replace('http://', 'https://') : null,
                streak: displayStreak, 
                steamUrl: data.steamUrl || '', 
                isCurrentUser: docItem.id === authUser.uid
              });
            }
          });
          
          players.sort((a, b) => b.level - a.level);
          const rankedPlayers = players.slice(0, 50).map((p, idx) => ({ ...p, rank: idx + 1 }));
          setLeaderboardData(rankedPlayers); 
          setLbPage(1); 
        } catch (error) {
          console.error("Leaderboard fetch error:", error);
        } finally {
          setIsLoadingLeaderboard(false);
        }
      };
      fetchLeaderboard();
    }
  }, [location.pathname, authUser]);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    }
  }, []);

  useEffect(() => {
    if (dailyTasks && dailyTasks.length > 0 && selectedPlan && skillLevel) {
      let needsUpdate = false;
      
      const hasDeprecatedTasks = dailyTasks.some(t => typeof t === 'string' && t.startsWith('t_std_'));
      const hasMissingTranslations = dailyTasks.some(t => typeof t === 'string' && t.startsWith('t_') && !translations['en'][t]);

      if (hasDeprecatedTasks || hasMissingTranslations) {
         needsUpdate = true;
      }

      if (needsUpdate) {
         const newTasks = getNewTasksForPlan(selectedPlan, skillLevel);
         setDailyTasks(newTasks);
         setCompletedTasks([]);
         if (auth.currentUser) {
           updateDoc(doc(db, "users", auth.currentUser.uid), {
             dailyTasks: newTasks,
             completedTasks: []
           }).catch(()=>{});
         }
      }
    }
  }, [dailyTasks, selectedPlan, skillLevel]);

  useEffect(() => {
    if (!authUser || isCheckingAuth || isInitialLoad) return; 

    const today = new Date();
    const todayStr = today.toDateString();
    const y = today.getFullYear();
    const m = today.getMonth(); 
    const activeKey = `${y}-${m}`;
    const currentIndex = today.getDate() - 1;
    
    setTodayIndex(currentIndex);
    setCurrentKey(activeKey);

    let createdStr = accountCreatedDate;
    if (!createdStr) {
      createdStr = todayStr;
      setAccountCreatedDate(todayStr); 
    }

    let updatedData = { ...calendarData };
    let stateChanged = false;

    if (!updatedData[activeKey]) {
      const daysInMonth = new Date(y, m + 1, 0).getDate();
      updatedData[activeKey] = Array.from({ length: daysInMonth }, () => ({ status: 'empty', planName: null }));
      stateChanged = true;
    }

    if (stateChanged) setCalendarData(updatedData);

    if (lastResetDate !== todayStr) {
      setResetsToday(0);
      setLastResetDate(todayStr);
      setCompletedTasks([]); 
      
      let newTasks = getNewTasksForPlan(selectedPlan, skillLevel);
      setDailyTasks(newTasks);

      if (auth.currentUser) {
        updateDoc(doc(db, "users", auth.currentUser.uid), {
          lastResetDate: todayStr,
          resetsToday: 0,
          completedTasks: [],
          dailyTasks: newTasks
        }).catch(()=>{});
      }
    }
  }, [lastResetDate, authUser, accountCreatedDate, selectedPlan, skillLevel, isCheckingAuth, isInitialLoad]); 

  const getDisplayStatus = (dayObj, year, month, dayIndex) => {
    let status = dayObj?.status || 'empty';
    const dayDate = new Date(year, month, dayIndex + 1);
    const today = new Date();
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const createdStr = accountCreatedDate || new Date().toDateString();
    const createdDateObj = new Date(createdStr);
    const createdDateOnly = new Date(createdDateObj.getFullYear(), createdDateObj.getMonth(), createdDateObj.getDate());

    if (dayDate >= createdDateOnly && dayDate < todayOnly && (status === 'empty' || status === 'yellow')) {
        return 'red';
    }
    return status;
  };

  const showAlert = (title, message) => setCustomAlert({ isOpen: true, type: 'alert', title, message, onConfirm: null });

  const handleLoginSubmit = async (e) => {
    e.preventDefault(); 
    const email = e.target[0].value;
    const pass = e.target[1].value;
    if (!email || !pass) return showAlert(t('error') || 'Error', t('fillRequired') || 'Please fill required fields');
    
    setIsCheckingAuth(true);
    try {
      await signInWithEmailAndPassword(auth, email, pass);
    } catch (error) {
      setIsCheckingAuth(false);
      showAlert(t('error') || 'Error', t('invalidLogin') || "Invalid email or password.");
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    const email = e.target[0].value;
    const pass = e.target[1].value;
    const passConfirm = e.target[2].value;

    if (!email || !pass || !passConfirm) return showAlert(t('error') || 'Error', t('fillRequired') || 'Please fill required fields');
    if (!/\S+@\S+\.\S+/.test(email)) return showAlert(t('error') || 'Error', t('invalidEmail') || 'Invalid email format');
    if (pass.length < 6) return showAlert(t('error') || 'Error', t('passTooShort') || 'Password too short');
    if (pass !== passConfirm) return showAlert(t('error') || 'Error', t('passMismatch') || 'Passwords do not match!');

    setIsCheckingAuth(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, pass);
      const creationDate = new Date().toDateString();
      
      await setDoc(doc(db, "users", userCredential.user.uid), {
        email: userCredential.user.email,
        username: '',
        createdAt: creationDate,
        streak: 0,
        stats: defaultStats,
        level: '',
        currentPlan: '',
        calendarData: {},
        lastCompletedDate: null,
        lifetimeTasksCompleted: 0,
        steamUrl: '',
        language: lang,
        dailyTasks: [],
        completedTasks: [],
        lastResetDate: '',
        resetsToday: 0
      });
    } catch (error) {
      setIsCheckingAuth(false);
      if (error.code === 'auth/email-already-in-use') {
        showAlert(t('error') || 'Error', t('accountExists') || 'Account already exists!');
      } else {
        showAlert(t('error') || 'Error', "Registration failed: " + error.message);
      }
    }
  };

  const handleConfirmNewPassword = async (e) => {
    e.preventDefault();
    const newPass = e.target[0].value;
    if (newPass.length < 6) return showAlert(t('error') || 'Error', t('passTooShort') || 'Password too short (min. 6 chars).');

    setIsCheckingAuth(true);
    try {
      await confirmPasswordReset(auth, resetCode, newPass);
      setIsCheckingAuth(false);
      showAlert(t('success') || 'Success', t('passwordChanged') || 'Password changed successfully! You can now log in.');
      setAuthMode('login');
      setResetCode(null);
      window.history.replaceState(null, '', window.location.pathname);
    } catch (error) {
      setIsCheckingAuth(false);
      showAlert(t('error') || 'Error', "Error: " + error.message);
    }
  };

  const submitPasswordReset = async (e) => {
    e.preventDefault();
    if (resetEmail && /\S+@\S+\.\S+/.test(resetEmail)) {
      try {
        await sendPasswordResetEmail(auth, resetEmail);
        setIsResetModalOpen(false);
        setResetEmail('');
        showAlert(t('success') || 'Success', t('resetLinkSent') || 'Password reset link sent to your email!');
      } catch (error) {
        showAlert(t('error') || 'Error', 'Error: ' + error.message);
      }
    } else {
      showAlert(t('error') || 'Error', t('invalidEmail') || 'Invalid email format.');
    }
  };

  const handleSocialLogin = async (providerName) => {
    if (providerName === 'Steam') {
      window.location.href = "https://us-central1-peekit-gg.cloudfunctions.net/steamLogin";
      return; 
    }

    if (providerName === 'Google' || providerName === 'Facebook') {
      const provider = providerName === 'Google' ? new GoogleAuthProvider() : new FacebookAuthProvider();
      setIsCheckingAuth(true); 
      try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        const userDoc = await getDoc(doc(db, "users", user.uid));
        
        if (!userDoc.exists()) {
          const creationDate = new Date().toDateString();
          await setDoc(doc(db, "users", user.uid), {
            email: user.email || '', 
            username: '', 
            createdAt: creationDate,
            streak: 0,
            stats: defaultStats,
            level: '',
            currentPlan: '',
            calendarData: {},
            lastCompletedDate: null,
            lifetimeTasksCompleted: 0,
            steamUrl: '',
            language: lang,
            dailyTasks: [],
            completedTasks: [],
            lastResetDate: '',
            resetsToday: 0
          });
        }
      } catch (error) {
        setIsCheckingAuth(false);
        if (error.code === 'auth/account-exists-with-different-credential') {
          showAlert(t('error') || 'Error', t('accountExistsDifferentMethod') || 'Account already exists! Use original login method.');
        } else if (error.code !== 'auth/popup-closed-by-user') {
          showAlert(providerName + ' Error', error.message);
        }
      }
    }
  };

  const handleLevelSelect = async (lvl) => {
    setSkillLevel(lvl);
    if (auth.currentUser) {
      try { await updateDoc(doc(db, "users", auth.currentUser.uid), { level: lvl }); } catch(e){}
    }
    navigate('/plans');
  };

  const handlePlanSelect = async (planName) => {
    setSelectedPlan(planName);
    
    let newTasks = getNewTasksForPlan(planName, skillLevel);
    setDailyTasks(newTasks);
    setCompletedTasks([]);

    if (auth.currentUser) {
      try { 
        await updateDoc(doc(db, "users", auth.currentUser.uid), { 
          currentPlan: planName,
          dailyTasks: newTasks,
          completedTasks: []
        }); 
      } catch(e){}
    }
    
    if (!username || username.trim() === '') {
      setIsUsernameModalOpen(true);
    }
    navigate('/dashboard');
  };

  const saveUsername = async (e) => {
    e.preventDefault();
    if (isSavingUsername) return; 
    setIsSavingUsername(true);

    const newName = tempUsername.trim();
    if (newName === '') {
      setIsSavingUsername(false);
      return showAlert(t('error') || 'Error', t('fillRequired') || 'Required');
    }
    if (isProfane(newName)) {
      setIsSavingUsername(false);
      return showAlert(t('error') || 'Error', t('profanityError') || 'This nickname contains inappropriate words. Please choose another.');
    }

    if (auth.currentUser) {
      try { await updateDoc(doc(db, "users", auth.currentUser.uid), { username: newName }); } catch(e){}
    }

    setUsername(newName);
    setIsUsernameModalOpen(false); 
    setIsSavingUsername(false);
  };

  const hasCompletedToday = lastCompletedDate === new Date().toDateString();

  const startTraining = () => {
    if (hasCompletedToday) {
      return showAlert('Anti-Cheat', t('trainingCompleted') || 'You have already completed your training for today!');
    }

    if (!selectedPlan || !skillLevel) return navigate('/level'); 
    
    let currentTasks = dailyTasks;
    if (!currentTasks || currentTasks.length === 0) {
      currentTasks = getNewTasksForPlan(selectedPlan, skillLevel);
      if (currentTasks.length === 0) {
        const translatedLevel = skillLevel === 'Beginner' ? t('begTitle') : skillLevel === 'Advanced' ? t('advTitle') : t('intTitle');
        currentTasks = [
          `${t('warmupTask') || 'Warmup training'} - ${selectedPlan} (15 min)`,
          `${t('mainTask') || 'Main training session'} - ${translatedLevel || skillLevel} (20 min)`,
          `${t('cooldownTask') || 'Analysis and cooldown'} (5 min)`
        ];
      }
      setDailyTasks(currentTasks);
      if (auth.currentUser) {
        updateDoc(doc(db, "users", auth.currentUser.uid), { dailyTasks: currentTasks }).catch(()=>{});
      }
    }

    let nextCalendar = JSON.parse(JSON.stringify(calendarData));
    if (!nextCalendar[currentKey] || !Array.isArray(nextCalendar[currentKey])) {
        const daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
        nextCalendar[currentKey] = Array.from({ length: daysInMonth }, () => ({ status: 'empty', planName: null }));
    }
    nextCalendar[currentKey][todayIndex] = { status: 'yellow', planName: selectedPlan };
    setCalendarData(nextCalendar);

    setTimeout(() => { setIsTrainingActive(true); }, 50);
  };

  const closeTrainingModal = () => {
    setIsTrainingActive(false);
    if (completedTasks.length === 0) {
      let nextCalendar = JSON.parse(JSON.stringify(calendarData));
      if (nextCalendar[currentKey] && nextCalendar[currentKey][todayIndex]) {
         if (nextCalendar[currentKey][todayIndex].status === 'yellow') {
             nextCalendar[currentKey][todayIndex] = { status: 'empty', planName: null };
             setCalendarData(nextCalendar);
         }
      }
    }
  };

  const toggleTask = (taskIndex) => {
    playTaskSound();
    let newCompleted;
    if (completedTasks.includes(taskIndex)) {
      newCompleted = completedTasks.filter(id => id !== taskIndex); 
    } else {
      newCompleted = [...completedTasks, taskIndex]; 
    }
    setCompletedTasks(newCompleted);

    if (auth.currentUser) {
      updateDoc(doc(db, "users", auth.currentUser.uid), { completedTasks: newCompleted }).catch(()=>{});
    }
  };

  const addXpToSkill = (currentStats, skillName, xpAmount) => {
    let newXp = currentStats[skillName].xp + xpAmount;
    let newLevel = currentStats[skillName].level;
    let reqXp = getRequiredXp(newLevel);
    
    while (newXp >= reqXp) {
      newXp -= reqXp;
      newLevel += 1;
      reqXp = getRequiredXp(newLevel);
    }
    return { level: newLevel, xp: newXp };
  };

  const finishTraining = async () => { 
    if (isClaimingReward) return;
    setIsClaimingReward(true);

    if (lastCompletedDate === new Date().toDateString()) {
      setIsTrainingActive(false);
      setIsClaimingReward(false);
      return showAlert('Anti-Cheat', t('trainingCompleted') || 'You have already claimed your reward for today!');
    }

    const today = new Date();
    let newStreak = streak;
    if (!lastCompletedDate) {
      newStreak = 1; 
    } else {
      const last = new Date(lastCompletedDate);
      const utcToday = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      const utcLast = Date.UTC(last.getFullYear(), last.getMonth(), last.getDate());
      const diffDays = Math.round((utcToday - utcLast) / (1000 * 60 * 60 * 24));

      if (diffDays === 0) {
        newStreak = streak === 0 ? 1 : streak; 
      } else if (diffDays === 1) {
        newStreak = streak + 1;
      } else {
        newStreak = 1;
      }
    }

    setStreak(newStreak);
    const newDateStr = today.toDateString();
    setLastCompletedDate(newDateStr);
    const newLifetimeTasks = lifetimeTasksCompleted + dailyTasks.length;
    setLifetimeTasksCompleted(newLifetimeTasks);

    const nextStats = JSON.parse(JSON.stringify(userStats)); 
    if (selectedPlan === 'Standard') {
      nextStats['Aim'] = addXpToSkill(nextStats, 'Aim', 15);
      nextStats['Utility'] = addXpToSkill(nextStats, 'Utility', 5);
      nextStats['Movement'] = addXpToSkill(nextStats, 'Movement', 5);
    } else {
      nextStats[selectedPlan] = addXpToSkill(nextStats, selectedPlan, 25);
    }
    setUserStats(nextStats); 

    let nextCalendar = JSON.parse(JSON.stringify(calendarData));
    if (!nextCalendar[currentKey] || !Array.isArray(nextCalendar[currentKey])) {
        const daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
        nextCalendar[currentKey] = Array.from({ length: daysInMonth }, () => ({ status: 'empty', planName: null }));
    }
    nextCalendar[currentKey][todayIndex] = { status: 'green', planName: selectedPlan };
    setCalendarData(nextCalendar);

    setShowConfetti(true);
    setTimeout(() => { setShowConfetti(false); }, 15000);

    if (auth.currentUser) {
      try {
        await updateDoc(doc(db, "users", auth.currentUser.uid), {
          streak: newStreak, 
          stats: nextStats, 
          level: skillLevel,
          currentPlan: selectedPlan,
          calendarData: nextCalendar,
          lastCompletedDate: newDateStr,
          lifetimeTasksCompleted: newLifetimeTasks,
          completedTasks: completedTasks,
          dailyTasks: dailyTasks
        });
      } catch (error) {
        console.error("Firebase save blocked:", error);
      }
    }

    setIsTrainingActive(false);
    setIsClaimingReward(false);
  };

  const handleLogout = async () => {
    setIsSidebarOpen(false); 
    
    if (auth.currentUser) {
      try {
        await updateDoc(doc(db, "users", auth.currentUser.uid), {
          streak: streak,
          stats: userStats,
          level: skillLevel,
          currentPlan: selectedPlan,
          calendarData: calendarData,
          lastCompletedDate: lastCompletedDate,
          lifetimeTasksCompleted: lifetimeTasksCompleted,
          dailyTasks: dailyTasks,
          completedTasks: completedTasks,
          lastResetDate: lastResetDate,
          resetsToday: resetsToday
        });
      } catch (e) { console.error("Logout save failed:", e); }
    }
    
    await signOut(auth);

    const savedLang = window.localStorage.getItem('peekit_lang');
    const savedCookies = window.localStorage.getItem('peekit_cookies_accepted');
    
    localStorage.clear();
    
    if (savedLang) window.localStorage.setItem('peekit_lang', savedLang);
    if (savedCookies) window.localStorage.setItem('peekit_cookies_accepted', savedCookies);
    
    setStreak(0);
    setUserStats(defaultStats);
    setSkillLevel('');
    setSelectedPlan('');
    setCalendarData({});
    setLastCompletedDate(null);
    setLifetimeTasksCompleted(0);
    setUsername('');
    setAvatarUrl(null); 
    setSteamUrl(''); 
    
    setDailyTasks([]);
    setCompletedTasks([]);
    setLastResetDate('');
    setResetsToday(0);
    
    setAuthMode('login'); 
    navigate('/'); 
  };

  const navigateTo = (path) => {
    navigate(path);
    setIsSidebarOpen(false); 
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      return showAlert('Error', 'File is too large! Maximum size is 2MB.');
    }

    const VISION_API_KEY = 'AIzaSyAOFkFhxW3jmjYBK__eZ5TtN576ppRhaKs'; 

    try {
      showAlert('Info', 'AI is analyzing your image...');
      
      const base64 = await fileToBase64(file);
      const base64Data = base64.split(',')[1];

      const response = await fetch(`https://vision.googleapis.com/v1/images:annotate?key=${VISION_API_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          requests: [{
            image: { content: base64Data },
            features: [
              { type: 'SAFE_SEARCH_DETECTION' },
              { type: 'WEB_DETECTION' },
              { type: 'LABEL_DETECTION' } 
            ]
          }]
        })
      });

      const data = await response.json();
      const result = data.responses?.[0];

      if (!result || result.error) {
         console.error("Szczegóły błędu Google:", result?.error || data);
         return showAlert('Error', 'AI verification failed. Try again.');
      }

      const safeSearch = result?.safeSearchAnnotation || {};
      const webDetection = result?.webDetection || {};
      const labels = result?.labelAnnotations || [];
      
      const isUnsafe = ['adult', 'violence', 'racy', 'gore'].some(
        category => safeSearch[category] === 'LIKELY' || safeSearch[category] === 'VERY_LIKELY'
      );

      const forbiddenTerms = ['hitler', 'adolf', 'nazi', 'swastika', 'fascism', 'reich', 'ss', 'nsdap', 'third reich', 'porn'];
      
      const allDetectedText = [
        ...(webDetection.webEntities || []).map(e => e.description || ''),
        ...(webDetection.bestGuessLabels || []).map(l => l.label || ''),
        ...labels.map(l => l.description || '')
      ].join(' ').toLowerCase();

      const hasForbiddenEntity = forbiddenTerms.some(term => {
        const regex = new RegExp(`\\b${term}\\b`, 'i');
        return regex.test(allDetectedText);
      });

      if (isUnsafe || hasForbiddenEntity) {
        console.warn("Zablokowano tagi:", allDetectedText);
        return showAlert('Error', 'Image rejected! Forbidden content or entity detected.');
      }

      showAlert('Info', 'Image accepted! Uploading...');

      const avatarRef = ref(storage, `avatars/${auth.currentUser.uid}`);
      await uploadBytes(avatarRef, file);
      const downloadURL = await getDownloadURL(avatarRef);

      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        photoURL: downloadURL
      });

      setAvatarUrl(downloadURL);
      showAlert('Success', 'Avatar updated successfully!');

    } catch (error) {
      console.error(error);
      showAlert('Error', 'Connection error. Please try again.');
    }
  };

  const handleSaveSettings = async () => {
    const newName = draftName.trim();
    if (newName === '') return showAlert(t('error') || 'Error', t('fillRequired') || 'Required');
    
    if (isProfane(newName)) {
      return showAlert(t('error') || 'Error', t('profanityError') || 'This nickname contains inappropriate words. Please choose another.');
    }

    setUsername(newName);
    setSteamUrl(draftSteamUrl);
    setLang(draftLang);

    let needsTaskReset = false;
    if (draftLevel !== skillLevel) {
      setSkillLevel(draftLevel);
      needsTaskReset = true;
    }
    if (draftPlan !== selectedPlan) {
      setSelectedPlan(draftPlan);
      needsTaskReset = true;
    }

    if (needsTaskReset) {
      const newTasks = getNewTasksForPlan(draftPlan, draftLevel);
      setDailyTasks(newTasks);
      setCompletedTasks([]);
      
      if (auth.currentUser) {
        updateDoc(doc(db, "users", auth.currentUser.uid), { dailyTasks: newTasks, completedTasks: [] }).catch(()=>{});
      }
    }

    if (auth.currentUser) {
      try {
        await updateDoc(doc(db, "users", auth.currentUser.uid), {
          level: draftLevel,
          currentPlan: draftPlan,
          username: newName,
          steamUrl: draftSteamUrl,
          language: draftLang 
        });
      } catch(e) {}
    }

    showAlert(t('success') || 'Success', t('settingsSaved') || 'Settings saved');
  };

  const handleChangeEmail = async (e) => {
    e.preventDefault();
    if (!newEmailInput || !/\S+@\S+\.\S+/.test(newEmailInput)) {
      return showAlert(t('error') || 'Error', t('invalidEmail') || 'Invalid email format');
    }

    if (auth.currentUser) {
      if (auth.currentUser.providerData.some(p => p.providerId === 'google.com')) {
        return showAlert('Blocked', 'Logged in via Google. Email changes must be done on your Google account.');
      }
      
      try {
        await updateEmail(auth.currentUser, newEmailInput);
        await updateDoc(doc(db, "users", auth.currentUser.uid), { email: newEmailInput });
        setCurrentEmail(newEmailInput);
        setNewEmailInput('');
        showAlert(t('success') || 'Success', 'Email address updated successfully!');
      } catch (error) {
        if (error.code === 'auth/requires-recent-login') {
          showAlert('Security', 'Please log out and log in again to change your email.');
        } else {
          showAlert('Error', error.message);
        }
      }
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPasswordInput.length < 6) {
      return showAlert(t('error') || 'Error', t('passTooShort') || 'Password too short (min 6 chars).');
    }

    if (auth.currentUser) {
      if (auth.currentUser.providerData.some(p => p.providerId === 'google.com')) {
        return showAlert('Blocked', 'Logged in via Google. Password settings are managed by Google.');
      }

      try {
        await updatePassword(auth.currentUser, newPasswordInput);
        setNewPasswordInput('');
        showAlert(t('success') || 'Success', 'Your password has been changed successfully!');
      } catch (error) {
        if (error.code === 'auth/requires-recent-login') {
          showAlert('Security', 'Please log out and log in again to change your password.');
        } else {
          showAlert('Error', error.message);
        }
      }
    }
  };

  const triggerReset = () => {
    if (resetsToday >= 2) return showAlert(t('limitReached') || 'Limit', t('resetLimitMsg') || 'Reset limit reached');
    
    setCustomAlert({
      isOpen: true, type: 'confirm', title: t('dangerZone') || 'Danger Zone', message: t('confirmResetMsg') || 'Reset progress?',
      onConfirm: () => {
        const newResets = resetsToday + 1;
        setResetsToday(newResets);
        setStreak(0);
        setLifetimeTasksCompleted(0);
        setUserStats(defaultStats);
        setCompletedTasks([]);
        setDailyTasks([]);
        setSelectedPlan('');
        setSkillLevel(''); 
        setLastCompletedDate(null);
        setAccountCreatedDate(new Date().toDateString());
        
        const today = new Date();
        const y = today.getFullYear();
        const m = today.getMonth();
        const activeKey = `${y}-${m}`;
        const daysInMonth = new Date(y, m + 1, 0).getDate();
        
        const resetCalendar = {
          [activeKey]: Array.from({ length: daysInMonth }, () => ({ status: 'empty', planName: null }))
        };
        
        setCalendarData(resetCalendar);
        const todayStr = new Date().toDateString();
        setLastResetDate(todayStr);

        if (auth.currentUser) {
          updateDoc(doc(db, "users", auth.currentUser.uid), {
            streak: 0, 
            stats: defaultStats, 
            level: '', 
            currentPlan: '',
            calendarData: resetCalendar,
            lastCompletedDate: null,
            lifetimeTasksCompleted: 0,
            dailyTasks: [],
            completedTasks: [],
            lastResetDate: todayStr,
            resetsToday: newResets
          }).catch(()=>{});
        }

        showAlert(t('success') || 'Success', t('resetSuccessMsg') || 'Progress reset');
        navigate('/level');
      }
    });
  };

  const totalLevel = userStats.Aim.level + userStats.Utility.level + userStats.Movement.level; 
  
  const getXpTotal = (skill) => {
    let total = 0;
    for(let i=1; i<userStats[skill].level; i++) {
      total += getRequiredXp(i);
    }
    return total + userStats[skill].xp;
  };
  
  const progressChartData = [
    { name: 'Day 1', Aim: 0, Utility: 0, Movement: 0 },
    { name: 'Today', Aim: getXpTotal('Aim'), Utility: getXpTotal('Utility'), Movement: getXpTotal('Movement') }
  ];

  const getTooltipContent = (dayObj) => {
    if (!dayObj) return '';
    if (dayObj.status === 'red') return t('missed') || 'Missed';
    if (dayObj.status === 'empty') return t('emptySlot') || 'Empty';
    if (dayObj.status === 'yellow') return t('trainingInProgress') || 'In Progress';
    if (dayObj.status === 'green') {
      if (dayObj.planName === 'Standard') return t('completedStandard') || 'Completed Standard';
      return `${t('completed') || 'Completed'} ${dayObj.planName || ''} (+25 XP)`;
    }
    return '';
  };

  const renderYearlyCalendar = () => {
    const y = new Date().getFullYear();
    const monthKeys = ['m0', 'm1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11'];

    return (
      <div className="yearly-grid">
        {monthKeys.map((mKey, mIndex) => {
          const key = `${y}-${mIndex}`;
          const daysInMonth = new Date(y, mIndex + 1, 0).getDate();
          const monthData = calendarData[key] || Array.from({ length: daysInMonth }, () => ({ status: 'empty' }));

          return (
            <div key={mIndex} className="mini-month">
              <h4>{t(mKey)}</h4>
              <div className="mini-days-grid">
                {monthData.map((d, dIdx) => {
                  const displayStatus = getDisplayStatus(d, y, mIndex, dIdx);
                  return (
                    <div key={dIdx} className={`mini-day mini-${displayStatus}`} title={`Day ${dIdx + 1}`}>
                      <span className="mini-day-number">{dIdx + 1}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
    );
  };

  const viewedYear = viewedDate.getFullYear();
  const viewedMonth = viewedDate.getMonth();
  const viewedKey = `${viewedYear}-${viewedMonth}`;
  const daysInViewedMonth = new Date(viewedYear, viewedMonth + 1, 0).getDate();
  const viewedMonthData = calendarData[viewedKey] || Array.from({ length: daysInViewedMonth }, () => ({ status: 'empty', planName: null }));
  const isCurrentMonthView = viewedKey === currentKey;
  
  const daysInCurrentMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
  const currentMonthData = calendarData[currentKey] || Array.from({ length: daysInCurrentMonth }, () => ({ status: 'empty', planName: null }));
  const todayStatus = getDisplayStatus(currentMonthData[todayIndex], new Date().getFullYear(), new Date().getMonth(), todayIndex);

  const showNicknameModal = Boolean(
    authUser && 
    skillLevel && 
    selectedPlan && 
    (!username || username.trim() === '') && 
    location.pathname === '/dashboard'
  );

  const filteredLeaderboard = leaderboardData.filter(player => 
    player.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalLbPages = Math.ceil(filteredLeaderboard.length / 10);
  const currentLbPageData = filteredLeaderboard.slice((lbPage - 1) * 10, lbPage * 10);

  if (isCheckingAuth) {
    return (
      <div className="app-container" style={{justifyContent: 'center', alignItems: 'center'}}>
        <style>{`
          @keyframes textGlow {
            0% { text-shadow: 0 0 10px rgba(239, 68, 68, 0.3); transform: scale(1); }
            50% { text-shadow: 0 0 40px rgba(239, 68, 68, 1); transform: scale(1.05); }
            100% { text-shadow: 0 0 10px rgba(239, 68, 68, 0.3); transform: scale(1); }
          }
          .glowing-text {
            animation: textGlow 2.5s infinite ease-in-out;
            color: #ef4444;
            font-size: 5rem;
            font-weight: bold;
            margin: 0;
            background: transparent;
          }
        `}</style>
        <div className="bg-graphics">
          <div className="bg-icon crosshair-icon"></div>
          <div className="bg-icon utility-icon"></div>
        </div>
        <h1 className="logo glowing-text">peekit.</h1>
      </div>
    );
  }

  return (
    <div className="app-container">
      
      <style>{`
        * {
          -webkit-tap-highlight-color: transparent !important;
        }
        .modal-content.training-modal {
          padding-bottom: 24px !important;
        }
        .task-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 0 !important;
        }
        .task-item {
          display: flex;
          align-items: center;
          min-height: 56px;
          margin: 0 !important;
          user-select: none;
          word-break: break-word;
        }
        .claim-reward-wrapper {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease-in, margin-top 0.4s ease-out;
          margin-top: 0;
          width: 100%;
        }
        .claim-reward-wrapper.show {
          max-height: 60px; 
          opacity: 1;
          margin-top: 20px;
        }
        .clickable-row, .primary-btn, .secondary-btn, button, .plan-card, .level-card, .map-card, .sidebar-item,
        .logo, .logo-header, .logo-small, .close-sidebar-btn, .close-modal-btn {
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        .sidebar-item.rewards-tab {
          color: #eab308 !important;
          font-weight: bold;
          text-shadow: 0 0 10px rgba(234, 179, 8, 0.3);
        }
        .sidebar-item.rewards-tab.active {
          background-color: rgba(234, 179, 8, 0.1) !important;
          border-left: 4px solid #eab308 !important;
        }
        .neon-badge-wrapper {
          position: relative;
          display: inline-block;
        }
        .neon-badge-icon {
          transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.15s ease;
        }
        .neon-badge-wrapper:hover .neon-badge-icon {
          transform: scale(1.15) translateY(-2px);
          filter: brightness(1.3);
        }
        .custom-tooltip {
          position: absolute;
          bottom: calc(100% + 10px);
          left: 50%;
          transform: translateX(-50%) translateY(5px);
          opacity: 0;
          visibility: hidden;
          background-color: #111;
          color: #fff;
          padding: 6px 12px;
          border-radius: 6px;
          border: 1px solid #333;
          font-size: 0.75rem;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 1px;
          white-space: nowrap;
          z-index: 9999;
          pointer-events: none;
          box-shadow: 0 4px 12px rgba(0,0,0,0.5);
          transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .neon-badge-wrapper:hover .custom-tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }
        @keyframes pulseGreen {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
          70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
        }
        .header-badges {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .active-players-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          background-color: #1a1a1a;
          padding: 6px 12px;
          border-radius: 20px;
          border: 1px solid #333;
          font-size: 0.8rem;
          color: #e5e5e5;
          font-weight: bold;
          white-space: nowrap;
        }
        .pulse-dot {
          width: 8px;
          height: 8px;
          background-color: #22c55e;
          border-radius: 50%;
          animation: pulseGreen 2s infinite;
          flex-shrink: 0;
        }
        @media (max-width: 480px) {
          .active-players-text {
            display: none; 
          }
          .active-players-badge {
            padding: 5px 8px;
            gap: 4px;
            font-size: 0.85rem;
          }
          .header-badges {
            gap: 5px; 
          }
          .close-modal-btn {
            top: 12px !important;
            right: 8px !important;
            font-size: 1.2rem !important;
          }
          .tasks-title {
            padding-right: 28px !important;
          }
        }
      `}</style>

      {isOffline && <div className="offline-banner">{t('offlineMsg')}</div>}

      {showConfetti && <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} numberOfPieces={400} />}

      {customAlert.isOpen && (
        <div className="modal-overlay" style={{ zIndex: 3000 }}>
          <div className="modal-content custom-alert">
            <h2 className="section-title" style={{ fontSize: '1.8rem', marginBottom: '10px' }}>{customAlert.title}</h2>
            <p className="subtitle-small" style={{ marginBottom: '25px', fontSize: '1.1rem' }}>{customAlert.message}</p>
            <div className="flex-row" style={{justifyContent: 'center'}}>
              {customAlert.type === 'confirm' && (
                <button className="secondary-btn" onClick={() => setCustomAlert({...customAlert, isOpen: false})}>{t('cancel') || 'Cancel'}</button>
              )}
              <button className="primary-btn" style={{marginTop: 0, padding: '12px 30px'}} onClick={() => {
                if(customAlert.onConfirm) customAlert.onConfirm();
                setCustomAlert({...customAlert, isOpen: false});
              }}>{t('ok') || 'OK'}</button>
            </div>
          </div>
        </div>
      )}

      {selectedPlayer && (
        <div className="modal-overlay" style={{ zIndex: 5000 }} onClick={() => setSelectedPlayer(null)}>
          <div className="modal-content custom-alert" style={{maxWidth: '350px'}} onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={() => setSelectedPlayer(null)}>✕</button>
            <div style={{textAlign: 'center', padding: '10px 0'}}>
               <div style={{fontSize: '4rem', marginBottom: '10px', display: 'flex', justifyContent: 'center'}}>
                 {selectedPlayer.avatar ? (
                    <img src={selectedPlayer.avatar} alt="Avatar" referrerPolicy="no-referrer" style={{width: '90px', height: '90px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #ef4444', boxShadow: '0 0 15px rgba(239, 68, 68, 0.3)'}} onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_AVATAR_666; }} />
                 ) : (
                    <div style={{width: '90px', height: '90px', borderRadius: '50%', backgroundColor: '#222', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #444', overflow: 'hidden'}}>
                      <Icons.Avatar size={46} color="#666" />
                    </div>
                 )}
               </div>
               <h2 style={{margin: '0 0 5px 0', fontSize: '1.8rem', color: '#fff'}}>{selectedPlayer.name}</h2>
               <p style={{color: '#a0a0a0', margin: '0 0 15px 0', fontWeight: 'bold'}}>{t('globalLvl') || 'Global Level'} {selectedPlayer.level}</p>
               {selectedPlayer.streak > 0 && (
                 <div style={{display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#1a1a1a', padding: '6px 16px', borderRadius: '20px', border: '1px solid #333', color: '#eab308', fontWeight: 'bold', letterSpacing: '1px'}}>
                   <Icons.Fire size={24} /> {selectedPlayer.streak} {t('dayStreak') || 'Day Streak'}
                 </div>
               )}
               <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '25px', borderTop: '1px solid #333', paddingTop: '20px'}}>
                  <div style={{textAlign: 'center', flex: 1}}>
                    <p style={{margin: '0 0 5px 0', color: '#a0a0a0', fontSize: '0.8rem', textTransform: 'uppercase'}}>Aim</p>
                    <strong style={{color: '#ef4444', fontSize: '1.4rem'}}>Lvl {selectedPlayer.aim}</strong>
                  </div>
                  <div style={{textAlign: 'center', flex: 1, borderLeft: '1px solid #333', borderRight: '1px solid #333'}}>
                    <p style={{margin: '0 0 5px 0', color: '#a0a0a0', fontSize: '0.8rem', textTransform: 'uppercase'}}>Utility</p>
                    <strong style={{color: '#eab308', fontSize: '1.4rem'}}>Lvl {selectedPlayer.util}</strong>
                  </div>
                  <div style={{textAlign: 'center', flex: 1}}>
                    <p style={{margin: '0 0 5px 0', color: '#a0a0a0', fontSize: '0.8rem', textTransform: 'uppercase'}}>Movement</p>
                    <strong style={{color: '#3b82f6', fontSize: '1.4rem'}}>Lvl {selectedPlayer.mov}</strong>
                  </div>
               </div>
               
               <div style={{marginTop: '20px', backgroundColor: '#1a1a1a', padding: '12px', borderRadius: '10px', border: '1px solid #333', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                 <p style={{margin: '0 0 10px 0', color: '#a0a0a0', fontSize: '0.8rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'center'}}>{t('badges') || 'Badges'}</p>
                 <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', width: '100%'}}>
                   {getAchievements(selectedPlayer, t).map((badge, idx) => (
                      <PlayerBadge key={idx} badge={badge} />
                   ))}
                 </div>
               </div>

               {selectedPlayer.steamUrl && (
                 <div style={{marginTop: '20px'}}>
                   <a href={selectedPlayer.steamUrl} target="_blank" rel="noreferrer" className="secondary-btn" style={{display: 'inline-block', textDecoration: 'none', width: '100%', padding: '12px 0', backgroundColor: '#171a21', color: '#fff', border: '1px solid #66c0f4'}}>
                      🎮 Steam Profile
                   </a>
                 </div>
               )}
            </div>
          </div>
        </div>
      )}

      {isResetModalOpen && (
        <div className="modal-overlay" style={{ zIndex: 4000 }}>
          <div className="modal-content custom-alert">
            <h2 className="section-title" style={{ marginBottom: '10px' }}>{t('resetPasswordTitle') || 'Reset Password'}</h2>
            <p className="subtitle-small">{t('resetPasswordDesc') || 'Enter your email address to receive a reset link.'}</p>
            <form onSubmit={submitPasswordReset} className="auth-form" style={{ marginTop: '20px' }} noValidate>
              <input type="email" placeholder={t('emailPlaceholder') || 'Email address'} value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} required />
              <div className="flex-row" style={{justifyContent: 'center', gap: '10px'}}>
                <button type="button" className="secondary-btn" onClick={() => setIsResetModalOpen(false)}>{t('cancel') || 'Cancel'}</button>
                <button type="submit" className="primary-btn" style={{marginTop: 0}}>{t('send') || 'Send'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showNicknameModal && (
        <div className="modal-overlay" style={{ zIndex: 4000 }}>
          <div className="modal-content custom-alert">
            <h2 className="section-title" style={{ marginBottom: '10px' }}>{t('welcomeTo') || 'Welcome!'}</h2>
            <p className="subtitle-small">{t('whatCallYou') || 'What should we call you?'}</p>
            <form onSubmit={saveUsername} className="auth-form" style={{ marginTop: '20px' }} noValidate>
              <input type="text" placeholder={t('enterUsername') || 'Enter Nickname'} value={tempUsername} onChange={(e) => setTempUsername(e.target.value)} required maxLength="15" />
              <button type="submit" className="primary-btn" disabled={isSavingUsername}>
                {isSavingUsername ? "Saving..." : (t('letsGo') || "Let's go")}
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="bg-graphics">
        <div className="bg-icon crosshair-icon"></div>
        <div className="bg-icon utility-icon"></div>
      </div>

      <Routes>
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
        <Route path="/" element={
          authUser ? <Navigate to="/dashboard" /> : ( // --- ZMIANA: authUser
            <div className="auth-box box-layer">
              <h1 className="logo">peekit.</h1>
              <p className="subtitle">{t('heroSubtitle')}</p>
              
              {authMode === 'login' ? (
                <form onSubmit={handleLoginSubmit} className="auth-form" noValidate>
                  <input type="email" placeholder={t('emailPlaceholder') || 'Email address'} required />
                  <input type="password" placeholder={t('passwordPlaceholder') || 'Password'} required />
                  <button type="submit" className="primary-btn" style={{backgroundColor: '#ef4444'}}>{t('login') || 'Log in'}</button>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '15px' }}>
                    <p className="auth-switch-text" onClick={() => setIsResetModalOpen(true)} style={{cursor: 'pointer', textAlign: 'center', margin: 0, color: '#a0a0a0', fontSize: '0.8rem'}}>
                      {t('forgotPasswordTxt') || "Forgot password?"} <span style={{color: '#ef4444', fontWeight: 'bold'}}>{t('resetHereTxt') || "Reset it here"}</span>
                    </p>
                    <p className="auth-switch-text" onClick={() => setAuthMode('register')} style={{cursor: 'pointer', textAlign: 'center', margin: 0, color: '#a0a0a0', fontSize: '0.9rem'}}>
                      {t('noAccount') || "Don't have an account?"} <span style={{color: '#ef4444', fontWeight: 'bold'}}>{t('createAccount') || 'Create Account'}</span>
                    </p>
                  </div>
                </form>
              ) : authMode === 'register' ? (
                <form onSubmit={handleRegisterSubmit} className="auth-form" noValidate>
                  <input type="email" placeholder={t('emailPlaceholder') || 'Email address'} required />
                  <input type="password" placeholder={t('passwordPlaceholder') || 'Password'} required />
                  <input type="password" placeholder={t('confirmPassword') || 'Confirm password'} required />
                  <button type="submit" className="primary-btn" style={{backgroundColor: '#ef4444'}}>{t('createAccount') || 'Create Account'}</button>
                  <p className="auth-switch-text" onClick={() => setAuthMode('login')} style={{cursor: 'pointer', textAlign: 'center', marginTop: '15px', color: '#a0a0a0', fontSize: '0.9rem'}}>
                    {t('hasAccount') || 'Already have an account?'} <span style={{color: '#ef4444', fontWeight: 'bold'}}>{t('login') || 'Log in'}</span>
                  </p>
                </form>
              ) : authMode === 'new-password' ? (
                <form onSubmit={handleConfirmNewPassword} className="auth-form" noValidate>
                  <p className="subtitle-small" style={{marginBottom: '20px'}}>{t('enterNewPassword') || 'Enter a new password for your account.'}</p>
                  <input type="password" placeholder={t('newPasswordPlaceholder') || 'New password (min. 6 chars)'} required minLength="6" />
                  <button type="submit" className="primary-btn" style={{backgroundColor: '#ef4444'}}>{t('saveNewPassword') || 'Save new password'}</button>
                  <p className="auth-switch-text" onClick={() => setAuthMode('login')} style={{cursor: 'pointer', textAlign: 'center', marginTop: '15px', color: '#a0a0a0', fontSize: '0.9rem'}}>
                    {t('cancel') || 'Cancel'}
                  </p>
                </form>
              ) : null}

              {authMode !== 'new-password' && (
                <>
                  <div className="social-divider">
                    <span>{t('orConnectWith')}</span>
                  </div>
                  <div className="social-buttons">
                    <button className="social-btn btn-steam" onClick={() => handleSocialLogin('Steam')}>Steam</button>
                    <button className="social-btn btn-google" onClick={() => handleSocialLogin('Google')}>Google</button>
                    <button className="social-btn btn-facebook" onClick={() => handleSocialLogin('Facebook')}>Facebook</button>
                  </div>
                </>
              )}
            </div>
          )
        } />

        <Route path="/level" element={
          !authUser ? <Navigate to="/" /> : ( // --- ZMIANA: authUser
            <div className="plans-box box-layer">
              <h1 className="logo-small">peekit.</h1>
              <h2>{t('chooseLevel')}</h2>
              <p className="subtitle-small">{t('levelDesc')}</p>
              <div className="plans-grid">
                <div className="level-card" onClick={() => handleLevelSelect('Beginner')}>
                  <h3>{t('begTitle')}</h3>
                  <div className="badges-row">
                    <div className="faceit-badge faceit-1-3"><span>1-3</span></div>
                    <div className="premier-badge premier-light-blue"><span>0 - 9,999</span></div>
                  </div>
                </div>
                <div className="level-card" onClick={() => handleLevelSelect('Intermediate')}>
                  <h3>{t('intTitle')}</h3>
                  <div className="badges-row">
                    <div className="faceit-badge faceit-4-7"><span>4-7</span></div>
                    <div className="premier-badge premier-dark-blue"><span>10,000+</span></div>
                  </div>
                </div>
                <div className="level-card" onClick={() => handleLevelSelect('Advanced')}>
                  <h3>{t('advTitle')}</h3>
                  <div className="badges-row">
                    <div className="faceit-badge faceit-8-10"><span>8-10</span></div>
                    <div className="premier-badge premier-pink"><span>20,000+</span></div>
                  </div>
                </div>
              </div>
            </div>
          )
        } />

        <Route path="/plans" element={
          (!authUser || !skillLevel) ? <Navigate to="/" /> : ( // --- ZMIANA: authUser
            <div className="plans-box box-layer">
              <h1 className="logo-small">peekit.</h1>
              <h2>{t('choosePlanTitle')}</h2>
              <p className="subtitle-small">{t('choosePlanDesc')}</p>
              <div className="plans-grid">
                {['Standard', 'Aim', 'Utility', 'Movement'].map(plan => (
                  <div key={plan} className="plan-card" onClick={() => handlePlanSelect(plan)}>
                    <h3>{plan}</h3>
                    <p>{t(`planDesc${plan}`)}</p>
                  </div>
                ))}
              </div>
            </div>
          )
        } />

        <Route path="*" element={
          <div className="not-found-screen box-layer">
            <h1 className="logo">{t('pageNotFound')}</h1>
            <p className="subtitle" style={{fontSize: '1.2rem'}}>{t('notFoundDesc')}</p>
            <button className="primary-btn" onClick={() => navigate('/dashboard')}>{t('defuseBtn')}</button>
          </div>
        } />

        <Route path="/:tab" element={
          !authUser ? <Navigate to="/" /> : ( // --- ZMIANA: authUser
            <div className="dashboard-box box-layer">
              <header className="dashboard-header">
                <div className="header-left">
                  <div className="icon-btn" onClick={() => setIsSidebarOpen(true)}>☰</div>
                  <h1 className="logo-header" onClick={() => navigateTo('/dashboard')}>peekit.</h1>
                </div>
                <div className="header-right header-badges">
                  {totalPlatformPlayers > 0 && (
                    <div className="active-players-badge">
                      <span className="pulse-dot"></span>
                      <span className="active-players-count">{totalPlatformPlayers}</span>
                      <span className="active-players-text">{getActiveText()}</span>
                    </div>
                  )}
                  <div className="streak-container" style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <Icons.Fire size={28} isGrayscale={streak === 0} />
                    <span className={`streak-count ${streak > 0 ? 'active-count' : ''}`}>{streak}</span> 
                  </div>
                </div>
              </header>

              <main className="dashboard-content">
                {location.pathname === '/dashboard' && (
                  <div className="fade-in">
                    <div className="calendar-wrapper">
                      <div className="month-navigation">
                        <button className="month-nav-btn" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => setViewedDate(new Date(viewedYear, viewedMonth - 1, 1))}>
                          <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                        </button>
                        <div className="calendar-title-container">
                          <h2 className="calendar-title">{t(`m${viewedMonth}`)} {viewedYear}</h2>
                          {!isCurrentMonthView && (
                            <button className="back-today-btn fade-in" onClick={() => setViewedDate(new Date())}>{t('backToToday')}</button>
                          )}
                        </div>
                        <button className="month-nav-btn" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => setViewedDate(new Date(viewedYear, viewedMonth + 1, 1))}>
                          <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                        </button>
                      </div>
                      <div className="calendar-grid">
                        {viewedMonthData.map((dayObj, index) => {
                          const displayStatus = getDisplayStatus(dayObj, viewedYear, viewedMonth, index);
                          return (
                            <div key={index} className={`cal-day day-${displayStatus} ${(isCurrentMonthView && index === todayIndex) ? 'today-highlight' : ''}`}>
                              <span className="day-number">{index + 1}</span>
                              <div className="cal-tooltip">{getTooltipContent({...dayObj, status: displayStatus})}</div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="calendar-legend">
                        <span><span className="dot dot-green"></span> {t('done')}</span>
                        <span><span className="dot dot-yellow"></span> {t('pending')}</span>
                        <span><span className="dot dot-red"></span> {t('missed')}</span>
                      </div>
                    </div>
                    <div className="training-section">
                      <p className="training-info">{t('todaysPlan')} <strong>{selectedPlan}</strong> ({t(`${skillLevel === 'Beginner' ? 'begTitle' : skillLevel === 'Advanced' ? 'advTitle' : 'intTitle'}`)})</p>
                      {hasCompletedToday ? (
                        <button className="primary-btn" style={{backgroundColor: '#22c55e', opacity: 0.7, cursor: 'default'}} disabled>{t('trainingCompleted') || 'Training completed'}</button>
                      ) : todayStatus === 'empty' ? (
                        <button className="primary-btn pulse-btn" onClick={startTraining}>{t('startTraining') || 'Start your training'}</button>
                      ) : todayStatus === 'yellow' ? (
                        <button className="primary-btn pulse-btn" style={{backgroundColor: '#eab308'}} onClick={startTraining}>{t('continueTraining') || 'Continue training'}</button>
                      ) : (
                        <button className="primary-btn" style={{backgroundColor: '#22c55e', opacity: 0.7, cursor: 'default'}} disabled>{t('trainingCompleted') || 'Training completed'}</button>
                      )}
                    </div>
                  </div>
                )}
                {location.pathname === '/rewards' && (
                  <div className="rewards-view fade-in" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', padding: '20px'}}>
                    <style>{`
                      @keyframes floatGlow {
                        0% { transform: translateY(0px); }
                        50% { transform: translateY(-10px); }
                        100% { transform: translateY(0px); }
                      }
                      .rewards-icon {
                        margin-bottom: 20px;
                        animation: floatGlow 3s ease-in-out infinite;
                      }
                    `}</style>
                    <div className="rewards-icon"><Icons.Diamond size={100} /></div>
                    <h2 className="section-title" style={{fontSize: '2.5rem', color: '#eab308', marginBottom: '15px'}}>{t('rewardsComingSoonTitle')}</h2>
                    <p className="subtitle" style={{maxWidth: '500px', margin: '0 auto', lineHeight: '1.6', fontSize: '1.2rem', color: '#a0a0a0'}}>
                      {t('rewardsComingSoonDesc')}
                    </p>
                    <button className="primary-btn" style={{marginTop: '30px', maxWidth: '250px'}} onClick={() => navigateTo('/dashboard')}>
                      {t('backToToday') || 'Powrót'}
                    </button>
                  </div>
                )}
                {location.pathname === '/calendar' && (
                  <div className="calendar-view fade-in">
                    <h2 className="section-title">{t('calendar')}</h2>
                    <p className="subtitle-small" style={{marginBottom: '30px'}}>{t('activityFor')} {new Date().getFullYear()}</p>
                    {renderYearlyCalendar()}
                  </div>
                )}
                {location.pathname === '/maps' && (
                  <div className="maps-view fade-in">
                    <h2 className="section-title">{t('maps')}</h2>
                    <div className="maps-grid">
                      {mapsData.map((map, index) => (
                        <a key={index} href={map.url} target="_blank" rel="noreferrer" className="map-card-link">
                          <div className="map-card">
                            <div className={`map-tag tag-${map.type.toLowerCase()}`}>{map.type}</div>
                            <h4>{map.name}</h4><p>{map.desc}</p>
                          </div>
                        </a>
                      ))}
                    </div>
                    <p style={{ textAlign: 'center', color: '#666', marginTop: '40px', fontSize: '0.9rem', fontStyle: 'italic' }}>
                      {t('moreMapsSoon') || 'More maps coming soon...'}
                    </p>
                  </div>
                )}
                {location.pathname === '/leaderboard' && (
                  <div className="leaderboard-view fade-in">
                    <style>{`
                      .leaderboard-container .leaderboard-row:nth-child(n) .rank {
                        color: #666 !important;
                        text-shadow: none !important;
                        font-size: 1.2rem !important; 
                        min-width: 50px !important; 
                        text-align: left !important;
                      }
                      .leaderboard-container .leaderboard-row .rank.rank-1 {
                        color: #eab308 !important;
                        text-shadow: 0 0 10px rgba(234, 179, 8, 0.5) !important;
                        font-size: 1.8rem !important; 
                      }
                      .leaderboard-container .leaderboard-row .rank.rank-2 {
                        color: #94a3b8 !important;
                        text-shadow: 0 0 10px rgba(148, 163, 184, 0.5) !important;
                        font-size: 1.6rem !important; 
                      }
                      .leaderboard-container .leaderboard-row .rank.rank-3 {
                        color: #b45309 !important;
                        text-shadow: 0 0 10px rgba(180, 83, 9, 0.5) !important;
                        font-size: 1.4rem !important; 
                      }
                    `}</style>
                    <div className="leaderboard-top-row">
                      <h2 className="section-title">{t('leaderboard')}</h2>
                      <input 
                        type="text" 
                        placeholder={t('searchPlayer') || 'Search player...'} 
                        className="search-bar" 
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                          setLbPage(1); 
                        }}
                      />
                    </div>
                    <div className="leaderboard-container">
                      {isLoadingLeaderboard ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                           <h1 className="logo glowing-text" style={{ fontSize: '2.5rem', margin: 0 }}>peekit.</h1>
                        </div>
                      ) : currentLbPageData.length > 0 ? (
                        currentLbPageData.map((player) => (
                          <div key={player.id} className={`leaderboard-row clickable-row ${player.isCurrentUser ? 'current-user-row' : ''}`} onClick={() => setSelectedPlayer(player)}>
                            <div className={`rank ${player.rank === 1 ? 'rank-1' : player.rank === 2 ? 'rank-2' : player.rank === 3 ? 'rank-3' : ''}`}>#{player.rank}</div>
                            <div className="player-info">
                              <span className="player-avatar" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#222', borderRadius: '50%', width: '40px', height: '40px', border: '1px solid #333'}}>
                                {player.avatar ? (
                                 <img src={player.avatar} alt="Avatar" className="lb-avatar-img" referrerPolicy="no-referrer" style={{width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover'}} onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_AVATAR_666; }} />
                                ) : (
                                  <Icons.Avatar size={20} color="#666" />
                                )}
                              </span>
                              <div className="player-details">
                                <span className="player-name">{player.name} {player.isCurrentUser && <span className="you-badge">({t('youBadge') || 'You'})</span>}</span>
                                <div className="player-substats">
                                  <span className="substat">AIM {player.aim}</span>
                                  <span className="substat">UTL {player.util}</span>
                                  <span className="substat">MOV {player.mov}</span>
                                </div>
                              </div>
                            </div>
                            <div className="player-level">Lvl {player.level}</div>
                          </div>
                        ))
                      ) : (
                        <p style={{textAlign: 'center', color: '#a0a0a0', padding: '20px'}}>Brak wyników wyszukiwania.</p>
                      )}
                    </div>
                    {!isLoadingLeaderboard && totalLbPages > 1 && (
                      <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px', flexWrap: 'nowrap' }}>
                        <button 
                          onClick={() => setLbPage(prev => Math.max(prev - 1, 1))} 
                          disabled={lbPage === 1}
                          className="secondary-btn"
                          style={{ width: 'auto', flex: '0 0 auto', padding: '8px 20px', margin: 0, opacity: lbPage === 1 ? 0.3 : 1, cursor: lbPage === 1 ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                        </button>
                        <span style={{ color: '#a0a0a0', fontWeight: 'bold', fontSize: '1.1rem', whiteSpace: 'nowrap' }}>
                          {lbPage} / {totalLbPages}
                        </span>
                        <button 
                          onClick={() => setLbPage(prev => Math.min(prev + 1, totalLbPages))} 
                          disabled={lbPage === totalLbPages}
                          className="secondary-btn"
                          style={{ width: 'auto', flex: '0 0 auto', padding: '8px 20px', margin: 0, opacity: lbPage === totalLbPages ? 0.3 : 1, cursor: lbPage === totalLbPages ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {location.pathname === '/progress' && (
                  <div className="progress-view fade-in">
                    <h2 className="section-title">{t('progress')}</h2>
                    <div className="stats-grid">
                      <div className="stat-box"><h3>{totalLevel}</h3><p>{t('globalLvl')}</p></div>
                      <div className="stat-box"><h3 style={{display:'flex', alignItems:'center', justifyContent:'center', gap:'8px'}}>{streak} <Icons.Fire size={32} /></h3><p>{t('dayStreak')}</p></div>
                      <div className="stat-box"><h3>{lifetimeTasksCompleted}</h3><p>{t('tasksComp')}</p></div>
                    </div>
                    
                    {/* --- NOWA SEKCJA ODZNAK W PROGRESS --- */}
                    <div style={{marginTop: '20px', marginBottom: '30px', backgroundColor: '#1a1a1a', padding: '20px', borderRadius: '12px', border: '1px solid #333', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <h3 style={{marginTop: 0, marginBottom: '15px', fontSize: '1.2rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <Icons.Trophy size={24} color="#eab308" />
                        {t('earnedBadges') || (
                          lang === 'pl' ? 'ZDOBYTE ODZNAKI' :
                          lang === 'uk' ? 'ОТРИМАНІ ЗНАЧКИ' :
                          lang === 'es' ? 'INSIGNIAS OBTENIDAS' :
                          lang === 'de' ? 'VERDIENTE ABZEICHEN' :
                          'EARNED BADGES'
                        )}
                      </h3>
                      <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center', width: '100%'}}>
                        {getAchievements({
                          streak: streak,
                          aim: userStats.Aim.level,
                          util: userStats.Utility.level,
                          mov: userStats.Movement.level,
                          level: totalLevel
                        }, t).map((badge, idx) => (
                          <PlayerBadge key={idx} badge={badge} />
                        ))}
                      </div>
                    </div>
                    {/* ----------------------------------- */}

                    <div className="progress-details" style={{marginBottom: '20px'}}>
                      <h3>{t('skillBreak')}</h3>
                      {['Aim', 'Utility', 'Movement'].map(skill => {
                        const reqXp = getRequiredXp(userStats[skill].level);
                        const progressPercent = Math.min((userStats[skill].xp / reqXp) * 100, 100);
                        return (
                          <div key={skill} className="progress-row">
                            <span className="progress-name">{skill} (Lvl {userStats[skill].level})</span>
                            <div className="progress-bar-bg"><div className="progress-bar-fill" style={{ width: `${progressPercent}%`, backgroundColor: skill === 'Aim' ? '#ef4444' : skill === 'Utility' ? '#eab308' : '#3b82f6' }}></div></div>
                            <span className="progress-xp">{userStats[skill].xp} / {reqXp} XP</span>
                          </div>
                        );
                      })}
                    </div>
                    <div className="chart-container fade-in">
                      <h3 style={{marginTop: 0, marginBottom: '20px', fontSize: '1.5rem'}}>{t('xpGrowth')}</h3>
                      <div style={{ width: '100%', height: 350 }}>
                        <ResponsiveContainer>
                          <LineChart data={progressChartData} margin={{ top: 35, right: 20, left: 0, bottom: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#333" vertical={false} />
                            <XAxis dataKey="name" stroke="#888" tick={{fill: '#888', dy: 10}} />
                            <YAxis stroke="#888" tick={{fill: '#888'}} domain={[0, dataMax => Math.max(50, Math.ceil(dataMax * 1.2))]} />
                            <RechartsTooltip contentStyle={{ backgroundColor: '#1a1a1a', borderColor: '#333', borderRadius: '8px', color: '#fff' }} itemStyle={{ fontWeight: 'bold' }} />
                            <Legend iconType="circle" wrapperStyle={{ paddingTop: '15px' }} />
                            <Line type="monotone" dataKey="Aim" stroke="#ef4444" strokeWidth={4} dot={{r: 6, fill: '#1a1a1a', strokeWidth: 2, stroke: '#ef4444'}} activeDot={{r: 8}} label={(props) => props.index === 1 ? <text x={props.x} y={props.y} dy={-15} fill="#ef4444" fontSize={14} fontWeight="bold" textAnchor="middle">{props.value}</text> : null} />
                            <Line type="monotone" dataKey="Utility" stroke="#eab308" strokeWidth={4} dot={{r: 6, fill: '#1a1a1a', strokeWidth: 2, stroke: '#eab308'}} activeDot={{r: 8}} label={(props) => props.index === 1 ? <text x={props.x} y={props.y} dy={-15} fill="#eab308" fontSize={14} fontWeight="bold" textAnchor="middle">{props.value}</text> : null} />
                            <Line type="monotone" dataKey="Movement" stroke="#3b82f6" strokeWidth={4} dot={{r: 6, fill: '#1a1a1a', strokeWidth: 2, stroke: '#3b82f6'}} activeDot={{r: 8}} label={(props) => props.index === 1 ? <text x={props.x} y={props.y} dy={-15} fill="#3b82f6" fontSize={14} fontWeight="bold" textAnchor="middle">{props.value}</text> : null} />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                )}
                {location.pathname === '/settings' && (
                  <div className="settings-view fade-in">
                    <h2 className="section-title">{t('accountSettings')}</h2>
                    <div className="settings-container">
                      <div className="settings-block">
                        <div className="setting-group">
                          <label>{t('language')}</label>
                          <select value={draftLang} onChange={(e) => setDraftLang(e.target.value)} className="setting-select">
                            <option value="en">English</option><option value="uk">Українська</option><option value="pl">Polski</option><option value="es">Español</option><option value="de">Deutsch</option><option value="fr">Français</option>
                          </select>
                        </div>
                        <div className="setting-group">
                          <label>{t('displayName')}</label>
                          <div className="setting-input-row flex-row"><input type="text" value={draftName} onChange={(e) => setDraftName(e.target.value)} maxLength="15" /></div>
                        </div>
                        <div className="setting-group" style={{marginTop: '5px'}}>
                          <label>Steam Profile URL</label>
                          <div className="setting-input-row flex-row"><input type="text" placeholder="https://steamcommunity.com/id/..." value={draftSteamUrl} onChange={(e) => setDraftSteamUrl(e.target.value)} /></div>
                        </div>
                        <div className="setting-group" style={{marginTop: '5px'}}>
                          <label>{t('currentSkill')}</label>
                          <select value={draftLevel} onChange={(e) => setDraftLevel(e.target.value)} className="setting-select">
                            <option value="Beginner">{t('begTitle')} (Faceit 1-3)</option><option value="Intermediate">{t('intTitle')} (Faceit 4-7)</option><option value="Advanced">{t('advTitle')} (Faceit 8-10)</option>
                          </select>
                        </div>
                        <div className="setting-group">
                          <label>{t('currentPlan')}</label>
                          <select value={draftPlan} onChange={(e) => setDraftPlan(e.target.value)} className="setting-select">
                            <option value="Standard">Standard (Mixed)</option><option value="Aim">Aim (Mechanics)</option><option value="Utility">Utility (Nades)</option><option value="Movement">Movement (Surfs/KZ)</option>
                          </select>
                        </div>
                        <button className="primary-btn" style={{marginTop: '15px'}} onClick={handleSaveSettings}>{t('saveSettings')}</button>
                      </div>
                      <hr className="settings-divider" />
                      <div className="settings-block">
                        <div className="setting-group">
                          <label>{t('emailAddr')}</label>
                          <form className="setting-input-row flex-row" onSubmit={handleChangeEmail} noValidate>
                            <input type="email" placeholder={t('emailPlaceholder')} value={newEmailInput} onChange={(e) => setNewEmailInput(e.target.value)} required />
                            <button type="submit" className="secondary-btn">{t('update') || 'Update'}</button>
                          </form>
                          <span className="current-info">{t('currentTxt') || 'Current'}: <strong>{currentEmail}</strong></span>
                        </div>
                        <div className="setting-group">
                          <label>{t('resetPass')}</label>
                          <form className="setting-input-row flex-row" onSubmit={handleChangePassword} noValidate>
                            <input type="password" placeholder={t('passwordPlaceholder') || 'New Password'} value={newPasswordInput} onChange={(e) => setNewPasswordInput(e.target.value)} required minLength="6" />
                            <button type="submit" className="secondary-btn">{t('reset') || 'Reset'}</button>
                          </form>
                        </div>
                      </div>
                      <hr className="settings-divider" />
                      <div className="setting-group danger-zone" style={{borderTop: 'none', paddingTop: 0, marginTop: 0}}>
                        <label>{t('dangerZone')}</label>
                        <button className="primary-btn" style={{backgroundColor: '#ef4444'}} onClick={triggerReset}>{t('resetProgress')}</button>
                      </div>
                    </div>
                  </div>
                )}
              </main>
            </div>
          )
        } />
      </Routes>

      {isTrainingActive && (
        <div className="modal-overlay" style={{ zIndex: 9999 }} onClick={(e) => { if(typeof e.target.className === 'string' && e.target.className.includes('modal-overlay')) closeTrainingModal(); }}>
          <div className="modal-content training-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={closeTrainingModal}>✕</button>
            <h3 className="tasks-title">{t('todaysMissions') || "Today's Missions"} <span>{selectedPlan}</span></h3>
            <div className="task-list">
              {dailyTasks && dailyTasks.length > 0 ? dailyTasks.map((task, index) => (
                <div key={index} className={`task-item ${completedTasks.includes(index) ? 'done' : ''}`} onClick={() => toggleTask(index)}>
                  <div className="checkbox">{completedTasks.includes(index) ? '✓' : ''}</div>
                  <span className="task-text">{t(task) || task}</span>
                </div>
              )) : <p style={{color: '#a0a0a0', textAlign: 'center'}}>Brak misji do załadowania.</p>}
            </div>
            <div className={`claim-reward-wrapper ${dailyTasks && dailyTasks.length > 0 && completedTasks.length === dailyTasks.length ? 'show' : ''}`}>
              <button className="success-btn" onClick={finishTraining} disabled={isClaimingReward}>
                {isClaimingReward ? "Claiming..." : (t('claimReward') || 'Claim Reward')}
              </button>
            </div>
          </div>
        </div>
      )}

      {authUser && ( // --- ZMIANA: authUser
        <>
          {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>}
          <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
              <h2 className="logo-small" onClick={() => navigateTo('/dashboard')} style={{cursor: 'pointer'}}>peekit.</h2>
              <button className="close-sidebar-btn" onClick={() => setIsSidebarOpen(false)}>✕</button>
            </div>
            <div className="sidebar-user-info">
              <div className="sidebar-avatar-container">
                <label htmlFor="avatar-upload" style={{cursor: 'pointer'}}>
                  {avatarUrl ? <img src={avatarUrl} alt="Avatar" className="sidebar-avatar-img" referrerPolicy="no-referrer" onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_AVATAR_888; }} /> : <div className="sidebar-avatar-placeholder" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Icons.Avatar size={36} color="#888" /></div>}
                  <div className="avatar-plus" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></div>
                </label>
                <input type="file" id="avatar-upload" accept="image/*" style={{display: 'none'}} onChange={handleAvatarUpload} />
              </div>
              <div><div className="sidebar-username">{username || 'Player'}</div></div>
            </div>
            <div className="sidebar-stats">
              {['Aim', 'Utility', 'Movement'].map(skill => {
                const reqXp = getRequiredXp(userStats[skill].level);
                const progressPercent = Math.min((userStats[skill].xp / reqXp) * 100, 100);
                return (
                  <div key={skill} className="stat-row">
                    <div className="stat-labels"><span>{skill}</span><span>Lvl {userStats[skill].level}</span></div>
                    <div className="stat-bar-bg"><div className="stat-bar-fill" style={{ width: `${progressPercent}%`, backgroundColor: skill === 'Aim' ? '#ef4444' : skill === 'Utility' ? '#eab308' : '#3b82f6' }}></div></div>
                  </div>
                );
              })}
            </div>
            <div className="sidebar-menu">
              <div className={`sidebar-item ${location.pathname === '/dashboard' ? 'active' : ''}`} onClick={() => navigateTo('/dashboard')}>{t('dashboard')}</div>
              <div className={`sidebar-item ${location.pathname === '/calendar' ? 'active' : ''}`} onClick={() => navigateTo('/calendar')}>{t('calendar')}</div>
              <div className={`sidebar-item ${location.pathname === '/maps' ? 'highlight active-highlight' : 'highlight'}`} onClick={() => navigateTo('/maps')}>{t('maps')}</div>
              <div className={`sidebar-item rewards-tab ${location.pathname === '/rewards' ? 'active' : ''}`} onClick={() => navigateTo('/rewards')} style={{display: 'flex', alignItems: 'center', gap: '8px'}}><Icons.Diamond size={18} color="#eab308" /> {t('rewards')}</div>
              <div className={`sidebar-item ${location.pathname === '/leaderboard' ? 'active' : ''}`} onClick={() => navigateTo('/leaderboard')}>{t('leaderboard')}</div>
              <div className={`sidebar-item ${location.pathname === '/progress' ? 'active' : ''}`} onClick={() => navigateTo('/progress')}>{t('progress')}</div>
              <div className={`sidebar-item ${location.pathname === '/settings' ? 'active' : ''}`} onClick={() => navigateTo('/settings')}>{t('settings')}</div>
            </div>
            
            {/* --- POŁĄCZONY FOOTER (LOGOUT + PRAWO) BEZ SUWAKA --- */}
            <div className="sidebar-footer" style={{ marginTop: 'auto', paddingBottom: '0', display: 'flex', flexDirection: 'column' }}>
              <div className="sidebar-item logout" onClick={handleLogout} style={{ margin: '0 0 4px 0' }}>{t('logout')}</div>
              
              <div style={{ textAlign: 'center', fontSize: '0.65rem', color: '#555' }}>
                <div style={{ marginBottom: '2px' }}>
                  <Link to="/terms" style={{ color: '#888', textDecoration: 'none', padding: '0 8px' }}>Terms</Link>
                  |
                  <Link to="/privacy" style={{ color: '#888', textDecoration: 'none', padding: '0 8px' }}>Privacy</Link>
                </div>
                <p style={{ margin: '0' }}>© 2026 peekit.</p>
              </div>
            </div>

          </div>
        </>
      )}

      {!cookiesAccepted && (
        <div className="cookie-banner slide-in" style={{
          position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
          backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '12px',
          padding: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: '20px', zIndex: 9999, width: '90%', maxWidth: '600px', boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
        }}>
          <p style={{ margin: 0, color: '#a0a0a0', fontSize: '0.9rem', lineHeight: '1.4' }}>
            We use cookies and local storage to keep you logged in, save your training progress, and analyze site traffic.
            By continuing to use <strong>peekit.</strong>, you agree to our use of cookies. 🍪
          </p>
          <button className="primary-btn" style={{ margin: 0, padding: '10px 20px', whiteSpace: 'nowrap', backgroundColor: '#ef4444' }}
            onClick={() => setCookiesAccepted(true)}>Got it!</button>
        </div>
      )}
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(error) { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div className="app-container" style={{flexDirection: 'column'}}>
          <h1 className="logo" style={{fontSize: '4rem', color: '#ff4b4b'}}>FATAL ERROR</h1>
          <p className="subtitle" style={{color: '#fff', fontSize: '1.2rem', marginBottom: '30px'}}>System encountered a critical failure.</p>
          <button className="primary-btn" onClick={() => { localStorage.clear(); window.location.reload(); }} style={{maxWidth: '300px'}}>Reboot System & Clear Data</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function AppWrapper() {
  return (
    <ErrorBoundary>
      <Router>
        <MainApp />
        <Analytics />
      </Router>
    </ErrorBoundary>
  );
}